define([
	"dojo/_base/declare",
	"csi/table/New"
], function(declare,New) {

	// summary: Controller to create Agent (Supplier with IsAgent=true) on a Supplier
	return declare(New, {
		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: on the create form, set value for IsAgent to be true and make it read only
			view.addFixedValue("IsAgent", true);

			this.inherited(arguments);
		}
	});
});